export enum TEST_IDS {
    LOGIN_SIGN_IN_BUTTON,
    DEV_LOGIN_EMAIL_INPUT,
    DEV_LOGIN_PASSWORD_INPUT,
    DEV_LOGIN_BUTTON,
    HOME_LINK,
    REQUESTS_LINK,
    ACCOUNT_LINK,
    SETTINGS_LINK,
    CONTACT_US_LINK,
    MENU_LINK,
    HOME_NEW_LEAVE_REQUEST_BUTTON,
    HOME_NEW_MEDICAL_REQUEST_BUTTON,
    HOME_NEW_PICKUP_REQUEST_BUTTON,
    HOME_MEDICAL_REQUESTS_SECTION,
    HOME_MEDICAL_REQUEST_CARD,
    HOME_MEDICAL_REQUEST_TOGGLE,
    HOME_MEDICAL_REQUEST_EDIT_BUTTON,
    HOME_MEDICAL_REQUEST_REVOKE_BUTTON,
    MEDICAL_REQUEST_NOTE_FIELD,
    MEDICAL_REQUEST_SUBMIT_BUTTON,
    MEDICAL_REQUEST_REVOKE_CONFIRM_BUTTON,
    MEDICAL_REQUEST_REVOKE_KEEP_BUTTON,
    HOME_PICKUP_REQUESTS_SECTION,
    HOME_PICKUP_REQUEST_CARD,
    HOME_PICKUP_REQUEST_TOGGLE,
    HOME_PICKUP_REQUEST_REVOKE_BUTTON,
    PICKUP_REQUEST_DATE_FIELD,
    PICKUP_REQUEST_PICKER_NAME_FIELD,
    PICKUP_REQUEST_RELATIONSHIP_FIELD,
    PICKUP_REQUEST_NOTE_FIELD,
    PICKUP_REQUEST_SUBMIT_BUTTON,
    PICKUP_REQUEST_REVOKE_CONFIRM_BUTTON,
    PICKUP_REQUEST_REVOKE_KEEP_BUTTON,
    HOME_STUDENT_ROW,
    HOME_STUDENT_ROW_NAME,
    HOME_STUDENT_ROW_SUBTITLE,
    ABSENCES_CREATE_LEAVE_REQUEST_BUTTON,
    STUDENT_CHIP,
    LEAVE_REQUEST_REASON_FIELD,
    LEAVE_REQUEST_DATE_FROM_FIELD,
    LEAVE_REQUEST_DATE_TO_FIELD,
    LEAVE_REQUEST_ALL_DAY_SWITCH,
    LEAVE_REQUEST_TIME_FROM_FIELD,
    LEAVE_REQUEST_TIME_TO_FIELD,
    LEAVE_REQUEST_ADDITIONAL_INFORMATION_TOGGLE,
    LEAVE_REQUEST_ADDITIONAL_INFORMATION_FIELD,
    LEAVE_REQUEST_SUBMIT_BUTTON,
    LEAVE_REQUEST_DETAIL_SCREEN,
    REQUESTS_SCREEN,
    REQUESTS_PERIOD_PREV,
    REQUESTS_PERIOD_NEXT,
    REQUESTS_PERIOD_TODAY,
    REQUESTS_PERIOD_LABEL,
    REQUESTS_FILTER_CHIP,
    REQUESTS_SECTION_ACTION_NEEDED,
    REQUESTS_SECTION_PERIOD,
    REQUESTS_LIST_ITEM,
    REQUESTS_LIST_ITEM_CHILD,
    REQUESTS_LIST_ITEM_REASON,
    REQUESTS_LIST_ITEM_STATUS,
    REQUESTS_LIST_ITEM_DATE_RANGE,
    REQUESTS_LIST_ITEM_OPEN_BUTTON,
    REQUESTS_LIST_ITEM_PROGRESS_EVENT,
    REQUESTS_LIST_ITEM_CANCEL_BUTTON,
    REQUESTS_LIST_ITEM_SCHOOL_MESSAGE,
    REQUESTS_LIST_ITEM_RESUBMIT_INPUT,
    REQUESTS_LIST_ITEM_RESUBMIT_BUTTON,
    REQUESTS_LIST_ITEM_RESUBMIT_OPEN_BUTTON,
    REQUESTS_LIST_ITEM_RESUBMIT_SCHOOL_MESSAGE,
    REQUESTS_CANCEL_CONFIRM_BUTTON,
    ABSENCES_CURRENT_REQUESTS_SECTION,
    SIGN_OUT_BUTTON,
    PROFILE_BACK_BUTTON,
    STACK_BACK_BUTTON,
    FAMILY_SCREEN,
    FAMILY_PROFILE_ROW,
    FAMILY_PROFILE_ROW_NAME,
    FAMILY_PROFILE_ROW_BADGE,
    FAMILY_PROFILE_ROW_SUBTITLE,
    PROFILE_FIELD_ROW,
    PROFILE_FIELD_INPUT,
    PROFILE_FIELD_SELECT,
    PROFILE_FIELD_READONLY_VALUE,
    PROFILE_SAVE_BUTTON,
    PROFILE_DISCARD_CHANGES_BUTTON,
    SETTINGS_SCREEN,
    SETTINGS_ACTIVE_SESSIONS_LINK,
    SETTINGS_NOTIFICATIONS_OPEN_SETTINGS_BUTTON,
    SETTINGS_BIOMETRIC_OPEN_SETTINGS_BUTTON,
    SETTINGS_DISPLAY_LANGUAGE_LINK,
    SETTINGS_DISPLAY_LANGUAGE_OPEN_SETTINGS_LINK,
    SETTINGS_DISPLAY_LANGUAGE_OPTION_DEFAULT,
    SETTINGS_DISPLAY_THEME_LINK,
    LANGUAGE_SCREEN,
    THEME_SCREEN,
    CONTACT_US_SCREEN,
    ACTIVE_SESSIONS_SCREEN,
    ACTIVE_SESSIONS_SIGN_OUT_ALL_BUTTON,
    ACTIVE_SESSIONS_CONFIRM_SIGN_OUT_ALL_BUTTON,
    ACTIVE_SESSIONS_SIGN_OUT_CURRENT_BUTTON,
    ACTIVE_SESSIONS_SIGN_OUT_OTHER_BUTTON,
    ACTIVE_SESSIONS_CONFIRM_SIGN_OUT_BUTTON,
    ATTACHMENT_ADD_BUTTON,
    ATTACHMENT_PICK_FILE_ITEM,
    ATTACHMENT_ROW_NAME,
    ATTACHMENT_ROW_OPEN_BUTTON,
    ATTACHMENT_ROW_REMOVE_BUTTON,
    ATTACHMENT_REMOVE_CONFIRM_BUTTON,
    REQUESTS_LIST_ITEM_UPDATE_END_DATE_OPEN_BUTTON,
    REQUESTS_LIST_ITEM_UPDATE_END_DATE_FIELD,
    REQUESTS_LIST_ITEM_UPDATE_END_DATE_ALL_DAY_SWITCH,
    REQUESTS_LIST_ITEM_UPDATE_END_DATE_TIME_TO_FIELD,
    REQUESTS_LIST_ITEM_UPDATE_END_DATE_SUBMIT_BUTTON,
    MENU_PARENT_CARD,
    MENU_PARENT_CARD_NAME,
    MENU_PARENT_CARD_EMAIL,
    MENU_PARENT_CARD_PHONE,
    PICKUP_REQUEST_END_DATE_FIELD,
    PICKUP_REQUEST_WEEKDAY_CHIP,
    PICKUP_REQUEST_REPEAT_FIELD,
    LEAVE_REQUEST_REPEAT_FIELD,
    LEAVE_REQUEST_WEEKDAY_CHIP,
    LEAVE_REQUEST_RECURRING_END_FIELD,
    ALERT_OK_BUTTON,
    HOME_STUDENT_ROW_NEXT_PICKUP,
    HOME_STUDENT_ROW_NEXT_PICKUP_PICKER,
    HOME_STUDENT_ROW_LEAVES_ALONE,
    HOME_STUDENT_PICKUP_ROW,
    HOME_STUDENT_ROW_BADGE,
    PICKUPS_CURRENT_REQUESTS_SECTION,
    PICKUPS_CREATE_PICKUP_REQUEST_BUTTON,
    PICKUPS_LEAVE_DAYS_ROW,
    PICKUPS_LEAVE_DAYS_VALUE,
    WHATS_NEW_CONTINUE,
    PICKUP_REQUEST_DAYS_FIELD,
    LEAVE_REQUEST_ABSENCE_FIELD,
    NOTIFICATIONS_BELL,
    NOTIFICATIONS_LIST,
    NOTIFICATIONS_LIST_ITEM,
    NOTIFICATIONS_LOAD_OLDER,
    NOTIFICATIONS_DELETE,
    NOTIFICATIONS_UNREAD_DOT,
    ABSENCE_REMINDER_DISMISS_BUTTON,
    ABSENCE_REMINDER_NEW_REQUEST_BUTTON,
}
